<div #overlaymap class="map">
    @if (loadingContent) {
      <div class="loading-message-wrapper">
        <div class="loading-message">
          <mat-spinner [diameter]="16" color="accent"></mat-spinner>
          <span>Loading map content ...</span>
        </div>
      </div>
    }
    <div class="basemap-toggle-wrapper"
         [ngClass]="{top: showBaseMapToggleOnTop(), bottom: !showBaseMapToggleOnTop()}"
    >
      @if (!!tenantConfiguration) {
        <app-basemap-toggle
                            [configuration]="tenantConfiguration"
        ></app-basemap-toggle>
      }
    </div>
</div>

